import React, { useState } from 'react';
import { API_ENDPOINTS } from '../config';
import './Socios2026.css';

function Socios2026() {
  const [documento, setDocumento] = useState('');
  const [mostrarModal, setMostrarModal] = useState(false);
  const [urlMercadoPago, setUrlMercadoPago] = useState('');
  const [tipoPago, setTipoPago] = useState('');
  const [error, setError] = useState('');

  const handleMercadoPagoClick = async (url, tipo) => {
    setError('');
    setTipoPago(tipo);
    setUrlMercadoPago(url);
    setMostrarModal(true);
  };

  const handleConfirmarPago = async () => {
    if (!documento.trim()) {
      setError('Por favor, ingrese su documento de identidad');
      return;
    }

    // Validar formato de documento (solo números)
    if (!/^\d+$/.test(documento.trim())) {
      setError('El documento debe contener solo números');
      return;
    }

    try {
      // Registrar el intento de pago
      const res = await fetch(`${API_ENDPOINTS.SOCIOS.replace('/socios', '')}/pagos-mercadopago/registrar-intento`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          documento: documento.trim(),
          tipoPago: tipoPago,
          urlMercadoPago: urlMercadoPago
        })
      });

      const data = await res.json();

      if (res.ok) {
        // Redirigir a MercadoPago
        window.location.href = urlMercadoPago;
      } else {
        setError(data.message || 'Error al registrar el pago. Por favor, intente nuevamente.');
      }
    } catch (err) {
      setError('Error de conexión. Por favor, intente nuevamente.');
      console.error('Error:', err);
    }
  };

  return (
    <div className="socios2026-bg">
      <div className="socios2026-card">
        <img 
          src={process.env.PUBLIC_URL + '/escudo_miramar.png'} 
          alt="Escudo Miramar" 
          className="escudo-socios2026" 
        />
        <h1 className="socios2026-title">
          Socios Miramar Misiones 2026
        </h1>

        <div className="socios2026-content">
          <section className="seccion-pago-cuota">
            <h2 className="seccion-titulo">💰 Abonar Cuota 2026</h2>
            
            <div className="precios-info">
              <h3 className="precios-titulo">Precios 2026</h3>
              <ul className="lista-precios">
                <li>
                  <strong>Hombre mayor de 17 años:</strong> $2.600
                </li>
                <li>
                  <strong>Damas y menores entre 12 y 17 años:</strong> $1.300
                </li>
                <li>
                  <strong>Menores de 12 años:</strong> Sin costo
                </li>
                <li className="opcional">
                  <strong>Carné socio edición 2026:</strong> $500
                </li>
              </ul>
            </div>

            <div className="metodo-pago">
              <h3 className="metodo-titulo">🏦 Transferencia Bancaria</h3>
              <div className="datos-bancarios">
                <p><strong>Banco:</strong> BROU</p>
                <p><strong>Cuenta:</strong> Club Sportivo Miramar Misiones</p>
                <p><strong>Número de cuenta actual:</strong> 001563852-00001</p>
                <p><strong>Para transferencia desde otros bancos:</strong> 00156385200001</p>
                <p className="instrucciones">
                  <strong>Importante:</strong> En la referencia agregar el documento de identidad.
                </p>
                <p className="instrucciones">
                  <strong>Enviar comprobante por WhatsApp al:</strong> <a href="https://wa.me/59898384570" target="_blank" rel="noopener noreferrer" className="link-whatsapp">+598 98 384 570</a>
                </p>
              </div>
            </div>

            <div className="metodo-pago">
              <h3 className="metodo-titulo">💳 MercadoPago</h3>
              <p className="texto-ayuda">
                Seleccione la opción que corresponda según su categoría y si desea incluir el carné social:
              </p>
              <div className="botones-mercadopago">
                <button 
                  className="btn-mercadopago"
                  onClick={() => handleMercadoPagoClick('https://mpago.la/2fK25Vk', 'hombre_mayor_carne')}
                >
                  Anualidad Hombre mayor de 17 años + carné 2026<br/>
                  <span className="precio">$3.100</span>
                </button>
                <button 
                  className="btn-mercadopago"
                  onClick={() => handleMercadoPagoClick('https://mpago.la/2K8TjiP', 'hombre_mayor')}
                >
                  Anualidad Hombre mayor de 17 años<br/>
                  <span className="precio">$2.600</span>
                </button>
                <button 
                  className="btn-mercadopago"
                  onClick={() => handleMercadoPagoClick('https://mpago.la/1DB6Foq', 'dama_menor_carne')}
                >
                  Anualidad Damas y menores entre 12 y 17 años + carné 2026<br/>
                  <span className="precio">$1.800</span>
                </button>
                <button 
                  className="btn-mercadopago"
                  onClick={() => handleMercadoPagoClick('https://mpago.la/2aH4QY1', 'dama_menor')}
                >
                  Anualidad Damas y menores entre 12 y 17 años<br/>
                  <span className="precio">$1.300</span>
                </button>
              </div>
            </div>
          </section>

          <section className="seccion-nuevo-socio">
            <h2 className="seccion-titulo">👤 ¿Querés hacerte socio nuevo?</h2>
            <p className="texto-destacado">
              Para inscribirte como nuevo socio, completa el siguiente formulario:
            </p>
            <div className="btn-formulario-container">
              <a 
                href="https://docs.google.com/forms/d/e/1FAIpQLScPMtvJEElZn499lGqd6cFZrt2aWRQXaoHcgbo6AxmL0YWyHA/viewform?usp=header"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-formulario"
              >
                📝 Completar Formulario de Inscripción
              </a>
            </div>
          </section>

          <section className="seccion-informacion">
            <p className="texto-informacion">
              💡 <strong>Una vez que seas socio del club</strong>, te recomendamos revisar tus datos en{' '}
              <a href="https://www.miramarmisiones.org.uy" target="_blank" rel="noopener noreferrer" className="link-informacion">
                www.miramarmisiones.org.uy
              </a>{' '}
              para que puedas estar enterado de nuestras novedades y beneficios.
            </p>
          </section>
        </div>

        {/* Modal para capturar documento */}
        {mostrarModal && (
          <div className="modal-overlay" onClick={() => setMostrarModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h3 className="modal-titulo">Ingrese su Documento de Identidad</h3>
              <p className="modal-texto">
                Para poder realizar el seguimiento de su pago, necesitamos su documento de identidad.
              </p>
              <input
                type="text"
                className="modal-input"
                placeholder="Ej: 12345678"
                value={documento}
                onChange={(e) => setDocumento(e.target.value)}
                maxLength="20"
                autoFocus
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleConfirmarPago();
                  }
                }}
              />
              {error && <p className="modal-error">{error}</p>}
              <div className="modal-botones">
                <button 
                  className="btn-modal-cancelar"
                  onClick={() => {
                    setMostrarModal(false);
                    setDocumento('');
                    setError('');
                  }}
                >
                  Cancelar
                </button>
                <button 
                  className="btn-modal-confirmar"
                  onClick={handleConfirmarPago}
                >
                  Continuar a MercadoPago
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Socios2026;
